var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { useFormRoot } from '../../../providers';
export const useFieldErrors = ({ fieldErrors, fieldId, }) => {
    _react_refresh_temp_1();
    const { methods: { registerFieldErrors }, } = useFormRoot();
    // Update form errors state on errors update:
    useEffect(() => {
        if (registerFieldErrors) {
            registerFieldErrors({ fieldErrors, fieldId });
        }
    }, [fieldId, fieldErrors]);
    // Remove from form the root
    // errors state on unmount:
    useEffect(() => {
        return () => {
            if (registerFieldErrors) {
                registerFieldErrors({ fieldErrors: [], fieldId });
            }
        };
    }, [fieldId]);
};
_react_refresh_temp_1(useFieldErrors, "6dJ6A1eIKDkuWfTdAuSqi2w+rv0=", false, () => [useFormRoot]);
